<template>
  <div class="mb-5">
    <div class="text-uppercase text-primary font-weight-bold py-3 px-4 border bg-light text-center">
      {{title}}
    </div>

    <div
      v-if="stages.length === 0"
      class="border-bottom border-right border-left bg-white p-4">
      Список пуст
    </div>

    <div
      v-for="stage in stages"
      :key="stage.id"
      class="">
      <div
        @click="$emit('select', stage.id)"
        class="py-3 px-4 border border-top-0 bg-light font-weight-bold text-primary position-relative cursor-pointer">
        {{stage.title}} ({{formatDate(stage.dateFrom, 'y-m-d')}} - {{formatDate(stage.dateTo, 'y-m-d')}})
      </div>

      <div
        v-for="goal in stage.goals"
        :key="goal.id"
        class="border-bottom border-right border-left bg-white">
        <div class="p-3 position-relative on-hover-wrapper">
          <div class="d-inline-block mr-2 cursor-pointer">
            {{goal.isCanceled() ? '&#10006;' : (goal.isAchieved() ? '&#10004;' : '&#9711;')}}
          </div>

          {{goal.startegyTitle}}

          <div
            v-if="userCanChangeStatus"
            class="position-absolute cursor-pointer on-hover-item"
            style="right: 10px; top:12px;">
            <span class="mr-2" @click="changeStatus(goal, stage, statusAchieved)">&#10004;</span>
            <span @click="changeStatus(goal, stage, statusCanceled)">&#10006;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';
import StrategyGoal from '../../../models/strategy/goal';

export default {
  name: 'ClientStrategyList',

  props: ['stages', 'title', 'userCanChangeStatus'],

  data() {
    return {
      statusAchieved: StrategyGoal.STATUS_ACHIEVED,
      statusCanceled: StrategyGoal.STATUS_CANCELED,
    };
  },

  methods: {
    changeStatus(goal, stage, status) {
      if (goal.status === status || !this.userCanChangeStatus) {
        return;
      }

      this.$emit('change', {goal, stage, status});
    },

    formatDate(dateString, format) {
      return formatDate(new Date(dateString), format);
    },
  },
};
</script>
